var cov_54ua86hmo = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/utils/validate/range.ts",
      hash = "3dbb64c933702d4aac9a906372b7ee90bbd8d78b",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/utils/validate/range.ts",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 2
        },
        end: {
          line: 25,
          column: 4
        }
      },
      "1": {
        start: {
          line: 5,
          column: 34
        },
        end: {
          line: 5,
          column: 41
        }
      },
      "2": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 10,
          column: 5
        }
      },
      "3": {
        start: {
          line: 8,
          column: 6
        },
        end: {
          line: 8,
          column: 20
        }
      },
      "4": {
        start: {
          line: 9,
          column: 6
        },
        end: {
          line: 9,
          column: 12
        }
      },
      "5": {
        start: {
          line: 12,
          column: 16
        },
        end: {
          line: 12,
          column: 41
        }
      },
      "6": {
        start: {
          line: 14,
          column: 4
        },
        end: {
          line: 18,
          column: 5
        }
      },
      "7": {
        start: {
          line: 16,
          column: 6
        },
        end: {
          line: 16,
          column: 34
        }
      },
      "8": {
        start: {
          line: 17,
          column: 6
        },
        end: {
          line: 17,
          column: 12
        }
      },
      "9": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 24,
          column: 5
        }
      },
      "10": {
        start: {
          line: 21,
          column: 6
        },
        end: {
          line: 21,
          column: 34
        }
      },
      "11": {
        start: {
          line: 23,
          column: 6
        },
        end: {
          line: 23,
          column: 20
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 3,
            column: 15
          },
          end: {
            line: 3,
            column: 16
          }
        },
        loc: {
          start: {
            line: 4,
            column: 2
          },
          end: {
            line: 25,
            column: 4
          }
        },
        line: 4
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 4,
            column: 11
          },
          end: {
            line: 4,
            column: 12
          }
        },
        loc: {
          start: {
            line: 4,
            column: 87
          },
          end: {
            line: 25,
            column: 3
          }
        },
        line: 4
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 7,
            column: 4
          },
          end: {
            line: 10,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 7,
            column: 4
          },
          end: {
            line: 10,
            column: 5
          }
        }, {
          start: {
            line: 7,
            column: 4
          },
          end: {
            line: 10,
            column: 5
          }
        }],
        line: 7
      },
      "1": {
        loc: {
          start: {
            line: 7,
            column: 8
          },
          end: {
            line: 7,
            column: 43
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 8
          },
          end: {
            line: 7,
            column: 27
          }
        }, {
          start: {
            line: 7,
            column: 31
          },
          end: {
            line: 7,
            column: 43
          }
        }],
        line: 7
      },
      "2": {
        loc: {
          start: {
            line: 14,
            column: 4
          },
          end: {
            line: 18,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 14,
            column: 4
          },
          end: {
            line: 18,
            column: 5
          }
        }, {
          start: {
            line: 14,
            column: 4
          },
          end: {
            line: 18,
            column: 5
          }
        }],
        line: 14
      },
      "3": {
        loc: {
          start: {
            line: 20,
            column: 4
          },
          end: {
            line: 24,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 20,
            column: 4
          },
          end: {
            line: 24,
            column: 5
          }
        }, {
          start: {
            line: 20,
            column: 4
          },
          end: {
            line: 24,
            column: 5
          }
        }],
        line: 20
      },
      "4": {
        loc: {
          start: {
            line: 20,
            column: 8
          },
          end: {
            line: 20,
            column: 88
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 20,
            column: 9
          },
          end: {
            line: 20,
            column: 32
          }
        }, {
          start: {
            line: 20,
            column: 36
          },
          end: {
            line: 20,
            column: 45
          }
        }, {
          start: {
            line: 20,
            column: 51
          },
          end: {
            line: 20,
            column: 74
          }
        }, {
          start: {
            line: 20,
            column: 78
          },
          end: {
            line: 20,
            column: 87
          }
        }],
        line: 20
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import nullable from './nullable';
export default (function (options) {
  cov_54ua86hmo.f[0]++;
  cov_54ua86hmo.s[0]++;
  return nullable(function (value, _formdata, callback) {
    cov_54ua86hmo.f[1]++;

    var _ref = (cov_54ua86hmo.s[1]++, options),
        min = _ref.min,
        max = _ref.max,
        message = _ref.message;

    cov_54ua86hmo.s[2]++;

    if ((cov_54ua86hmo.b[1][0]++, value === undefined) || (cov_54ua86hmo.b[1][1]++, value === '')) {
      cov_54ua86hmo.b[0][0]++;
      cov_54ua86hmo.s[3]++;
      callback(true);
      cov_54ua86hmo.s[4]++;
      return;
    } else {
      cov_54ua86hmo.b[0][1]++;
    }

    var val = (cov_54ua86hmo.s[5]++, parseFloat(String(value)));
    cov_54ua86hmo.s[6]++;

    if (Number.isNaN(val)) {
      cov_54ua86hmo.b[2][0]++;
      cov_54ua86hmo.s[7]++;
      // console.error(new Error(`Can not convert value '${value}' to Number, validate failed.`))
      callback(new Error(message));
      cov_54ua86hmo.s[8]++;
      return;
    } else {
      cov_54ua86hmo.b[2][1]++;
    }

    cov_54ua86hmo.s[9]++;

    if ((cov_54ua86hmo.b[4][0]++, typeof min === 'number') && (cov_54ua86hmo.b[4][1]++, val < min) || (cov_54ua86hmo.b[4][2]++, typeof max === 'number') && (cov_54ua86hmo.b[4][3]++, val > max)) {
      cov_54ua86hmo.b[3][0]++;
      cov_54ua86hmo.s[10]++;
      callback(new Error(message));
    } else {
      cov_54ua86hmo.b[3][1]++;
      cov_54ua86hmo.s[11]++;
      callback(true);
    }
  });
});